var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 93,
    viewBox: "0 0 100 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7539_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7907 44.1742L23.2559 37.1992V88.7375C23.2559 91.0912 25.1644 92.9992 27.5186 92.9992H95.7373C98.0915 92.9992 100 91.0912 100 88.7375V69.7492L62.7907 44.1742Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7907 0H27.5186C25.1644 0 23.2559 1.90803 23.2559 4.26171V23.25L62.7907 46.5L83.721 53.475L100 46.5V23.25L62.7907 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2559 23.25H62.7907V46.5H23.2559V23.25Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.5512 18.5996H23.2559V76.7246H51.5512C53.9023 76.717 55.8064 74.8134 55.814 72.4629V22.8613C55.8064 20.5108 53.9023 18.6073 51.5512 18.5996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.2256 20.9258H23.2559V79.0508H49.2256C51.5767 79.0431 53.4808 77.1396 53.4884 74.7891V25.1875C53.4808 22.837 51.5767 20.9334 49.2256 20.9258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.2256 20.9258H23.2559V74.4008H49.2256C51.5767 74.3931 53.4808 72.4896 53.4884 70.1391V25.1875C53.4808 22.837 51.5767 20.9334 49.2256 20.9258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.9001 20.9258H23.2559V74.4008H46.9001C49.2511 74.3931 51.1552 72.4896 51.1628 70.1391V25.1875C51.1552 22.837 49.2511 20.9334 46.9001 20.9258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26278 20.9258H46.9C49.2542 20.9258 51.1627 22.8338 51.1627 25.1875V67.814C51.1627 70.1677 49.2542 72.0757 46.9 72.0757H4.26278C1.90851 72.0758 0 70.1678 0 67.8141V25.1875C0 22.8338 1.90851 20.9258 4.26278 20.9258Z",
    fill: "url(#paint0_linear_7539_231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2031 60.3516L22.1706 46.4597L13.9543 32.6445H20.5636L25.0473 41.4795C25.4613 42.3188 25.745 42.9419 25.8985 43.3535H25.9566C26.2512 42.6839 26.5613 42.0336 26.8868 41.4028L31.6799 32.6492H37.7473L29.3217 46.383L37.9613 60.3515H31.5055L26.3264 50.654C26.0824 50.2414 25.8754 49.808 25.7078 49.359H25.6311C25.4794 49.7989 25.2781 50.2201 25.0311 50.6145L19.6985 60.3516H13.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7375 0H62.791V23.25H100V4.26171C100 1.90803 98.0918 0 95.7375 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.791 46.5H100V69.75H62.791V46.5Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7539_231",
    x1: 8.88801,
    y1: 17.5958,
    x2: 42.2623,
    y2: 75.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7539_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcel);
export default __webpack_public_path__ + "static/media/msExcel_.e3a5c71e9adfcde21fed5ad3d99f4428.svg";
export { ForwardRef as ReactComponent };